import jsonExport from "jsonexport/dist";
import { get } from "lodash";
import moment from "moment";
import { downloadCSV } from "react-admin";

const getInfo = ({ record, source, translate }) => {
	const isTotal = get(record, "is_total");
	if (isTotal) {
		return "";
	}
	const data = JSON.parse(get(record, source));
	const method = JSON.parse(get(record, "method.config", "{}"));
	if (data === null) {
		return translate("resources.user-payments.no_payment_method_info");
	}
	const keys = Object.keys(data);
	const taxType = get(record, "tax_type", "person");
	const withholdingTaxReturn = get(record, "withholding_tax_return");

	return [
		`${translate("resources.payment-methods.name")}: ${get(
			record,
			"method.name",
			"NA"
		)}`,
		keys
			.filter((key) => get(method, key) !== undefined)
			.map((key) => ({
				name: translate(
					`ra.profile.fields.${key.startsWith(".") ? key.substr(1) : key}`
				),
				value: data[key],
			}))
			.reduce((prev, current) => {
				let value = (prev += `${current.name}: ${current.value}\n`);
				return value;
			}, ""),
		`${translate("resources.users.fields.profile.tax_type")}: ${translate(
			`resources.profiles.tax_type.${taxType}`
		)}`,
		taxType === "person" &&
			`${translate("resources.user-payments.fields.withholding_tax_return")}: ${
				withholdingTaxReturn
					? translate("ra.action.yes")
					: translate("ra.action.no")
			}`,
	].join("\n");
};

const formatter = (props, lang = "it-IT") => Intl.NumberFormat(lang, props);

const exporter = (records, translate) => {
	const data = records.map((record) => {
		return {
			[translate("resources.users.name", 1)]: get(record, "user.name", ""),
			[translate("resources.user-payments.fields.range")]: !record.is_total
				? moment(`${get(record, "year")}-${get(record, "month")}-01`).format(
						"MMMM YYYY"
				  )
				: "",
			[translate("resources.user-payments.fields.amount")]: formatter({
				style: "currency",
				currency: "EUR",
			}).format(get(record, "amount", 0)),
			Status: get(record, "status.name", ""),
			[translate(
				"resources.user-payments.fields.payment_method_data"
			)]: getInfo({ record, source: "payment_method_data", translate }),
		};
	});
	jsonExport(
		data,
		{
			headers: [
				translate("resources.users.name", 1),
				translate("resources.user-payments.fields.range"),
				translate("resources.user-payments.fields.amount"),
				"Status",
				translate("resources.user-payments.fields.payment_method_data"),
			],
		},
		(err, csv) => {
			downloadCSV("\uFEFF" + csv, translate("menu.items.user-payments")); // download as 'posts.csv` file
		}
	);
};

export default exporter;
